import { useModal } from "@stadium/hooks/lib/use-modal";

import TemplateInfoModal from "@components/modals/template-info";

import { TEMPLATE_INFO } from "@constants/modal-types";

const emptyObj = {};

const useTemplateInfoModal = (templateInfoData = emptyObj,) => {
  const { openModal: openTemplateInfoModal, renderModal: renderTemplateInfoModal } = useModal(
    TEMPLATE_INFO,
    TemplateInfoModal,
  );

  return [
    openTemplateInfoModal,
    renderTemplateInfoModal({

      data: {
        templateInfoData,
      }
    }, false,),
  ];
};

export default useTemplateInfoModal;
